import Vue from 'vue'
import {
    _
} from 'underscore'

export default {
  state: {
    createCustomer: false,
    existingCustomer: false,
    sameAsPrimary: true,
    preFlightResponse: null,
    transferDate: null,
    destinationCustomer: null,
    transferBankDetails: {
      AccountName: null,
      AccountNumber: null,
      SortCode: null,
      DdOrganisationId: null,
    },
    transferExistingBankDetails: null,
    transferServices: null,
    serviceBundle: null,
    contractStartDate: null,
    contractTerm: null,
    contractType: null,
    activeStep: 0,
    serviceDetails: [],
    transferResponse: null,
    transferServiceBundleSearch: null,
    transferServiceBundle: null,
  },
  mutations: {
    refreshTransfer(state) {
      state.createCustomer = false;
      state.existingCustomer = false;
      state.sameAsPrimary = false;
      state.preFlightResponse = null;
      state.transferDate = null;
      state.destinationCustomer = null;
      state.transferBankDetails = {
        AccountName: null,
        AccountNumber: null,
        SortCode: null,
        DdOrganisationId: null,
      };
      state.transferExistingBankDetails = null;
      state.transferServices = null;
      state.serviceBundle = null;
      state.contractStartDate = null;
      state.contractTerm = null;
      state.activeStep = 0;
      state.serviceDetails = [];
      state.transferServiceBundleSearch = '';
      state.contractType= null;
    },
    updateServiceDetails(state, details) {
      state.transferServices = details;
    },
    updateActiveStep(state, active) {
      state.activeStep = active;
    },
    updateTransferBankDetails(state, details) {
      state.transferBankDetails = details;
    },
    resetTransferBankDetails(state) {
      state.transferBankDetails = {
        AccountName: null,
        AccountNumber: null,
        SortCode: null,
        DdOrganisationId: null,
      };
    },
    updateTransferExistingBankDetails(state, bankDetails) {
      state.transferExistingBankDetails = bankDetails;
    },
    updatePreFlightResponse(state, preFlightResponse) {
      state.preFlightResponse = preFlightResponse;
    },
    updateTransferDate(state, date) {
      state.transferDate = date;
      state.contractStartDate = date;
    },
    updateContractStartDate(state, date) {
      state.contractStartDate = date;
    },
    updateContractTerm(state, term) {
      state.contractTerm = term;
    },
    updateContractType(state, contractType) {
      state.contractType = contractType;
    },
    updateServiceBundle(state, bundle) {
      state.serviceBundle = bundle;
    },
    updateTransferServices(state, selected) {
      // state.transferServices = []
      state.transferServices = selected;

      state.transferServices.forEach((service, index) => {
        var currentMetersOnCotDate = _.sortBy(
          _.filter(service.Meters, function(meter) {
            return state.transferDate > meter.Installed 
            && (meter.Removed == null || state.transferDate < meter.Removed)
          }),
          'Installed'
        );

        if (service.Service.ServiceType == 'Gas') {
          Vue.set(service, 'CurrentMeter', currentMetersOnCotDate[0]);
          Vue.set(service, 'PriorityServices', []);
          Vue.set(service, 'ReadingDate', state.transferDate);
          Vue.set(service, 'ReadingSource', 'SuppliedByEndUser');
          Vue.set(service, 'Reading', []);
          Vue.set(service, 'IsValidReading', false);
          Vue.set(service, 'Override', false);
          Vue.set(
            service,
            'CCA',
            Vue.config.honeycomb.commercialConfig.ccaReductionPercentage
          );
          Vue.set(
            service,
            'Commercial',
            Vue.config.honeycomb.commercialConfig.commercialPercentage
          );
          Vue.set(service, 'ExemptionType', 'NotExempt');
          Vue.set(
            service,
            'ApplicationRule',
            'WhenBillingIsHigherThanIndustry'
          );

          Vue.set(state.transferServices, index, service);
        }
        if (service.Service.ServiceType == 'Electricity') {
          var measurementMethod = _.sortBy(
            service.MeterPoint.MeterPointConfigs,
            'EffectiveFrom'
          ).reverse()[0].MeasurementMethod;

          var billingEac = [];
          var registerReadings = [];

          currentMetersOnCotDate.forEach((meter) => {
            var registers = _.sortBy(
              meter.MeterConfigs,
              'EffectiveFrom'
            ).reverse()[0].Registers;
            registers.forEach((register) => {
              billingEac.push({
                BillingEac: null,
                RegisterId: register.RegisterId,
                Serial: meter.Serial,
              });
              if (register.IsSettlement) {
                registerReadings.push({
                  Serial: meter.Serial,
                  MeterRegisterId: register.RegisterId,
                  BillingTypeId: register.BillingTypeId,
                  Digits: register.Digits,
                  IsValid: false,
                  Reading: [],
                });
              }
            });
          });

          Vue.set(service, 'MeasurementMethod', measurementMethod);
          Vue.set(service, 'CurrentMeters', currentMetersOnCotDate);
          Vue.set(service, 'PriorityServices', []);
          Vue.set(service, 'ReadingType', 'ChangeOfTenancy');
          Vue.set(service, 'ReadingDate', state.transferDate);
          Vue.set(service, 'RegisterReadings', registerReadings);
          Vue.set(
            service,
            'IsValidReading',
            measurementMethod == 'HalfHourly' ? true : false
          );
          Vue.set(service, 'Override', false);
          Vue.set(
            service,
            'CCA',
            Vue.config.honeycomb.commercialConfig.ccaReductionPercentage
          );
          Vue.set(
            service,
            'Commercial',
            Vue.config.honeycomb.commercialConfig.commercialPercentage
          );
          Vue.set(service, 'ExemptionType', 'NotExempt');
          Vue.set(
            service,
            'ApplicationRule',
            'WhenBillingIsHigherThanIndustry'
          );
          Vue.set(service, 'EacLevel', null);
          Vue.set(service, 'MeterPointBillingEac', null);
          Vue.set(service, 'BillingEac', billingEac);

          Vue.set(state.transferServices, index, service);
        }
      });
    },
    updateDestinationCustomer(state, customer) {
      state.destinationCustomer = customer;
    },
    updateCreateCustomer(state, bool) {
      state.createCustomer = bool;
    },
    updateExistingCustomer(state, bool) {
      state.existingCustomer = bool;
    },
    updateSameAsPrimary(state, bool) {
      state.sameAsPrimary = bool;
    },
    updateTransferResponse(state, response) {
      state.transferResponse = response;
    },
    updateTransferServiceBundleSearch(state, search) {
      state.transferServiceBundleSearch = search;
    },
  },
  actions: {
    getPreFlight({ state, rootState, commit }) {
      return Vue.prototype.$http
        .post(
          'https://' +
            Vue.config.honeycomb.contractbot.domain +
            '/api/v1/Transfers/preflight',
          {
            CustomerId: rootState.customers.customer.Id,
            TransferDate: state.transferDate,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          commit('updatePreFlightResponse', response.data);
        });
    },
    setTransferServices({ commit }, selected) {
      commit('updateTransferServices', selected);
    },
    setDestinationCustomer({ dispatch }, document) {
      dispatch('getDestinationCustomer', document.CustomerId);
    },
    getDestinationCustomer({ commit, dispatch }, Id) {
      Vue.prototype.$http
        .get(
          'https://' +
            Vue.config.honeycomb.contractbot.domain +
            '/api/v1/Customers/' +
            Id,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          commit('updateDestinationCustomer', response.data);
          dispatch('getTransferExistingBankDetails', response.data);
        });
    },
    getTransferExistingBankDetails({ commit }, customer) {
      Vue.prototype.$http
        .get(
          'https://' +
            Vue.config.honeycomb.ddbot.domain +
            '/api/v1/lodgements?accountId=' +
            customer.AccountId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          commit('updateTransferExistingBankDetails', response.data);
        });
    },
  },
};